import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { ParticipantsPluginService } from '../participants/participants-plugin.service';
import { InspectionService } from '../../shared/services';

@Component({
    templateUrl: './actionparticipants.component.html',
    standalone: false
})
export class ActionParticipantsPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public participants: any[];
  public inspection: Inspection;

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private inspectionService: InspectionService
  ) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    const inspectionId = this.plugin.actionPlan.inspectionId;
    if (!inspectionId) {
      return;
    }
    this.inspectionService.getInspection(inspectionId).subscribe((inspection) => {
      if (!inspection || !inspection.allPlugins) {
        return;
      }
      const participantsPlugin = inspection.allPlugins.find((p) => p.pluginType === 'participants');

      if (!participantsPlugin || !participantsPlugin.config.Participants) {
        return;
      }
      this.participants = participantsPlugin.config.Participants.filter(
        (p) => p.Name && this.plugin.config.Participants.includes(p.Id)
      ).sort((a, b) => {
        const nameA = a.Name.toUpperCase();
        const nameB = b.Name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });

    // this.plugin.config.Participants;
    this.cdRef.detectChanges();
  }

  initData() {}

  getEditRoute() {
    return [
      this.actionPlansRoute,
      this.plugin.actionPlanId,
      'actionplanitems',
      this.plugin.actionPlanItemId,
      'plugins',
      this.plugin.id,
      'participants',
      'edit'
    ];
  }
}

PluginComponent.plugins['actionparticipants'] = ActionParticipantsPluginComponent;
